import { get, putJson } from '../httpClient';

/**
 * Client for /api/org/:orgId/notification-prefs.
 *
 * Owner-only — the server rejects non-owners with 403
 * (requirePermission('MANAGE_SUBSCRIPTION')). Returned `prefs` always
 * contains every known key (server fills in defaults), so the UI can
 * render a toggle for each without first having to check what's missing.
 */
export const orgNotificationsAPI = {
  /** GET /api/org/:orgId/notification-prefs */
  getPrefs: orgId => get(`/api/org/${orgId}/notification-prefs`),

  /** PUT /api/org/:orgId/notification-prefs — body: { prefs: { … } } */
  updatePrefs: (orgId, prefs) =>
    putJson(`/api/org/${orgId}/notification-prefs`, { prefs }),
};
